/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdbiologie10Inputs */

const en__field_enum_sdbiologie10 = /** @type {(inputs: _Field_Enum_Sdbiologie10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 - Biowissenschaften`)
};

const de__field_enum_sdbiologie10 = /** @type {(inputs: _Field_Enum_Sdbiologie10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 - Biowissenschaften`)
};

/**
* | output |
* | --- |
* | "15 - Biowissenschaften" |
*
* @param {_Field_Enum_Sdbiologie10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdbiologie10 = /** @type {((inputs?: _Field_Enum_Sdbiologie10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdbiologie10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdbiologie10(inputs)
	return de__field_enum_sdbiologie10(inputs)
});
export { _field_enum_sdbiologie10 as "_field_enum_SDBIOLOGIE" }